import React from 'react';
import Card from '../../ui/Card';
const PipelineFunnelChart: React.FC = () => {
  const funnelData = [{
    stage: 'New Business Pipeline',
    value: 4850,
    percentage: 100,
    color: 'bg-blue-500'
  }, {
    stage: 'RFQ Stage',
    value: 3280,
    percentage: 68,
    color: 'bg-blue-600'
  }, {
    stage: 'Awarded',
    value: 1820,
    percentage: 38,
    color: 'bg-green-500'
  }, {
    stage: 'SOP (Start of Production)',
    value: 925,
    percentage: 19,
    color: 'bg-green-600'
  }];
  return <Card className="p-6" data-id="element-8833">
      <h3 className="text-lg font-semibold text-gray-800 mb-4" data-id="element-8834">
        New Business Pipeline Funnel
      </h3>
      <div className="space-y-4 py-4" data-id="element-8835">
        {funnelData.map((stage, index) => <div key={index} className="relative" data-id="element-8836">
            <div className="flex items-center justify-between mb-2" data-id="element-8837">
              <span className="text-sm font-medium text-gray-700" data-id="element-8838">
                {stage.stage}
              </span>
              <span className="text-sm font-semibold text-gray-800" data-id="element-8839">
                ₹{stage.value} Cr
              </span>
            </div>
            <div className="relative h-12 bg-gray-100 rounded-lg overflow-hidden" data-id="element-8840">
              <div className={`h-full ${stage.color} flex items-center justify-end px-4 transition-all duration-500`} style={{
            width: `${stage.percentage}%`
          }} data-id="element-8841">
                <span className="text-white font-medium text-sm" data-id="element-8842">
                  {stage.percentage}%
                </span>
              </div>
            </div>
          </div>)}
      </div>
      <div className="mt-4 pt-4 border-t border-gray-200" data-id="element-8843">
        <div className="flex justify-between text-sm" data-id="element-8844">
          <span className="text-gray-600" data-id="element-8845">
            Conversion Rate (Pipeline to SOP)
          </span>
          <span className="font-semibold text-gray-800" data-id="element-8846">19%</span>
        </div>
      </div>
    </Card>;
};
export default PipelineFunnelChart;